// extracted by mini-css-extract-plugin
export default {"alertContainer":"HotelList_alertContainer__jLoMt","button":"HotelList_button__a6432"};